
(function () {
  'use strict';

  const ROOT_ID = 'jf-collection-filters';

  const SIZE_LABELS = [
    'Tiny Newborn', 'Newborn',
    '0-3 M', '3-6 M', '6-9 M', '9-12 M',
    '12-18 M', '18-24 M',
    '2-3 Y', '3-4 Y', '4-5 Y', '5-6 Y',
    '6-7 Y', '7-8 Y', '8-9 Y', '9-10 Y',
    '10-11 Y', '11-12 Y', '12-13 Y', '13-14 Y',
    '14-15 Y', '15-16 Y',
    '0-4 Year', '4-8 Year', '8-12 Year', '12-16 Year',
    'EU-23', 'EU-24', 'EU-25', 'EU-26', 'EU-27',
    'EU-28', 'EU-29', 'EU-30', 'EU-31', 'EU-32',
    'EU-33', 'EU-34', 'EU-35', 'EU-36', 'EU-37'
  ];

  const TYPE_LABELS = [
    'Booties', 'Boys Booties', 'Girls Booties',
    'Clogs', 'Boys Clogs', 'Girls Clogs',
    'Sandals', 'Boys Sandals', 'Girls Sandals',
    'Slippers', 'Boys Slippers', 'Girls Slippers',
    'Shoes', 'Boys Shoes', 'Girls Shoes',
    'Boys Footwear', 'Girls Footwear',
    'Track Suits', 'Boys Track Suits', 'Girls Track Suits',
    'Hoodies & Jackets', 'Boys Hoodies & Jackets',
    'Girls Hoodies & Jackets',
    'Sweatshirts', 'Boys Sweatshirts', 'Girls Sweatshirts',
    'Sweater & Cardigan', 'Boys Sweater & Cardigan',
    'Girls Sweater & Cardigan',
    'Night Suits', 'Boys Night Suits', 'Girls Night Suits',
    'Rompers & Body Suits', 'Boys Rompers & Body Suits',
    'Girls Rompers & Body Suits',
    'Pants', 'Boys Pants', 'Girls Pants',
    'Trousers', 'Boys Trousers', 'Girls Trousers',
    'Shorts', 'Boys Shorts',
    'Frocks & Dresses', 'Suits & Dresses',
    'T-shirts & Polos', 'Boys T-shirts & Polos',
    'Girls T-shirts & Polos',
    'Underwear & Shorts', 'Underwear & Briefs',
    'Leggings & Tights',
    'Swimsuits', 'Boys Swimsuits', 'Girls Swimsuits',
    'Caps', 'Socks', 'Bibs', 'Diaper Bags', 'School Bags',
    'Hair Accessories', 'Feeding & Sipping',
    'Towels & Blankets', 'Vests',
    'Accessories', 'Clothing', 'Footwear', 'Baby Care Products'
  ];

  const SIZE_KEYS = new Set(SIZE_LABELS.map(normalize));
  const TYPE_KEYS = new Set(TYPE_LABELS.map(normalize));

  let renderQueued = false;

  function normalize(value) {
    return String(value || '')
      .normalize('NFKD')
      .toLowerCase()
      .replace(/&/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function getRoot() {
    return document.getElementById(ROOT_ID);
  }

  function getCollectionPath(root) {
    return root.dataset.collectionUrl.replace(/\/+$/, '');
  }

  function getTagMap(root) {
    const script = root.querySelector('[data-jf-tag-map]');
    const entries = script
      ? parseJson(script.textContent, [])
      : [];

    const byHandle = new Map();
    const byLabel = new Map();

    entries.forEach(function (entry) {
      if (!entry || !entry.label || !entry.handle) return;

      const item = {
        label: String(entry.label),
        handle: String(entry.handle).toLowerCase()
      };

      byHandle.set(item.handle, item);
      byLabel.set(normalize(item.label), item);
    });

    return { byHandle, byLabel };
  }

  function getCurrentHandles(root, tagMap) {
    const collectionPath = getCollectionPath(root);
    const pathname = window.location.pathname.replace(/\/+$/, '');

    if (
      pathname !== collectionPath &&
      !pathname.startsWith(collectionPath + '/')
    ) {
      return [];
    }

    const remainder = pathname.slice(collectionPath.length);
    const segment = remainder.replace(/^\/+/, '');

    if (segment) {
      return segment.split('+').map(function (part) {
        try {
          return decodeURIComponent(part).toLowerCase();
        } catch (error) {
          return part.toLowerCase();
        }
      }).filter(Boolean);
    }

    // Fallback for collection pages without tag handles in the URL.
    const currentTags = parseJson(root.dataset.currentTags || '[]', []);

    if (!Array.isArray(currentTags)) return [];

    return currentTags.map(function (tag) {
      const entry = tagMap.byLabel.get(normalize(tag));
      return entry ? entry.handle : normalize(tag);
    });
  }

  function classifyHandle(handle, tagMap) {
    const entry = tagMap.byHandle.get(handle);

    if (!entry) return null;

    const key = normalize(entry.label);

    if (SIZE_KEYS.has(key)) return 'size';
    if (TYPE_KEYS.has(key)) return 'type';

    return null;
  }

  function buildUrl(root, handles) {
    const collectionPath = getCollectionPath(root);
    const uniqueHandles = Array.from(new Set(handles.filter(Boolean)));
    const path = uniqueHandles.length
      ? collectionPath + '/' + uniqueHandles.join('+')
      : collectionPath;

    const params = new URLSearchParams(window.location.search);
    params.delete('page');

    const query = params.toString();

    return path + (query ? '?' + query : '');
  }

  function createButton(label, href, active, reset) {
    const link = document.createElement('a');

    link.className = 'jf-filter-button';
    if (active) link.classList.add('is-active');
    if (reset) link.classList.add('jf-filter-reset');

    link.textContent = label;
    link.href = href;
    link.setAttribute('aria-pressed', active ? 'true' : 'false');
    link.setAttribute('data-collection-render', '');

    return link;
  }

  function renderGroup(root, container, entries, group, handles, tagMap) {
    if (!container) return;

    container.replaceChildren();

    const selectedInGroup = handles.filter(function (handle) {
      return classifyHandle(handle, tagMap) === group;
    });

    const otherHandles = handles.filter(function (handle) {
      return classifyHandle(handle, tagMap) !== group;
    });

    container.appendChild(createButton(
      group === 'size' ? 'All Sizes' : 'All Types',
      buildUrl(root, otherHandles),
      selectedInGroup.length === 0,
      true
    ));

    entries.forEach(function (entry) {
      const active = handles.includes(entry.handle);

      let nextHandles;

      if (active) {
        // Clicking an active option removes only that option.
        nextHandles = handles.filter(function (handle) {
          return handle !== entry.handle;
        });
      } else {
        // Keep the other group and replace this group's selection.
        nextHandles = otherHandles.concat(entry.handle);
      }

      container.appendChild(createButton(
        entry.label,
        buildUrl(root, nextHandles),
        active,
        false
      ));
    });
  }

  function init() {
    const root = getRoot();
    if (!root) return;

    const allTags = parseJson(root.dataset.allTags || '[]', []);
    if (!Array.isArray(allTags)) return;

    const tagMap = getTagMap(root);

    const availableSizes = SIZE_LABELS
      .map(function (label) {
        return tagMap.byLabel.get(normalize(label));
      })
      .filter(Boolean);

    const availableTypes = TYPE_LABELS
      .map(function (label) {
        return tagMap.byLabel.get(normalize(label));
      })
      .filter(Boolean);

    const currentHandles = getCurrentHandles(root, tagMap);

    renderGroup(
      root,
      root.querySelector('[data-jf-size-options]'),
      availableSizes,
      'size',
      currentHandles,
      tagMap
    );

    renderGroup(
      root,
      root.querySelector('[data-jf-type-options]'),
      availableTypes,
      'type',
      currentHandles,
      tagMap
    );
  }
  
function scheduleRender() {
  if (renderQueued) return;

  renderQueued = true;

  requestAnimationFrame(function () {
    renderQueued = false;

    const root = getRoot();
    if (!root) return;

    // Read the URL after Foxic updates browser history.
    const tagMap = getTagMap(root);
    const currentHandles = getCurrentHandles(root, tagMap);

    const allTags = parseJson(root.dataset.allTags || '[]', []);
    if (!Array.isArray(allTags)) return;

    const availableSizes = SIZE_LABELS
      .map(function (label) {
        return tagMap.byLabel.get(normalize(label));
      })
      .filter(Boolean);

    const availableTypes = TYPE_LABELS
      .map(function (label) {
        return tagMap.byLabel.get(normalize(label));
      })
      .filter(Boolean);

    renderGroup(
      root,
      root.querySelector('[data-jf-size-options]'),
      availableSizes,
      'size',
      currentHandles,
      tagMap
    );

    renderGroup(
      root,
      root.querySelector('[data-jf-type-options]'),
      availableTypes,
      'type',
      currentHandles,
      tagMap
    );
  });
}

  function start() {
    init();

    // Foxic AJAX replaces product listings without reloading the page.
    // Watch for that replacement and refresh our active-button state.
    const observer = new MutationObserver(function (mutations) {
      const changed = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;

          return (
            node.matches('[data-product-listing], [data-collection-title]') ||
            node.querySelector('[data-product-listing], [data-collection-title]')
          );
        });
      });

      if (changed) scheduleRender();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('popstate', scheduleRender);
    window.addEventListener('jf:collection-updated', scheduleRender);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
